import { SvgIcon } from '@mui/material'
import * as React from 'react'
import { ReactComponent as E3DCBunny } from './Osterhase_E3DC.svg'
import { ReactComponent as FlowBunnySVG } from './Osterhase_Hager.svg'

interface Props {
  style?: React.CSSProperties
  isFlowTheme?: boolean
}

const EasterBunny: React.FC<Props> = ({ style, isFlowTheme }): React.ReactElement => (
  <SvgIcon style={style}>{isFlowTheme ? <FlowBunnySVG /> : <E3DCBunny />}</SvgIcon>
)

export default EasterBunny
